import { render } from "./ChatFile.vue?vue&type=template&id=31575808&scoped=true"
import script from "./ChatFile.vue?vue&type=script&lang=js"
export * from "./ChatFile.vue?vue&type=script&lang=js"

import "./ChatFile.vue?vue&type=style&index=0&id=31575808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31575808"]])

export default __exports__